import HttpService from '@book24/client-api/dist/services/HttpService';

const $html = document.querySelector('html');

export default new HttpService({
  baseUrl: '',
  sessid: $html.dataset.sessid,
  isFormData: true,
});
